module.exports = __webpack_public_path__ + "static/media/undefined-avatar.44f7266b.png";